<template>
  <div class="row">
    <div class="upperSidebar" v-if="categories">
      <ul class="upperSidebar__list">
        <PublicUpperSidebarLink
          v-if="token.scopes.includes('read_summary_data')"
          route-name="Summary"
          name="Summary"
          :current-page="currentPage"
          @pageChanged="openPage(null, $event)"
        />
        <span v-for="(category, index) in categories" v-bind:key="index">
          <PublicUpperSidebarLink
            :route-name="category.name"
            :name="category.name"
            :current-page="currentPage"
            @pageChanged="openPage(category, $event)"
          />
        </span>
      </ul>
    </div>
  </div>
</template>

<script>
import UpperSidebarLink from './UpperSidebarLink';
import PublicUpperSidebarLink from '@/components/SidebarPlugin/PublicUpperSidebarLink';
export default {
  name: 'PublicSidebar',
  components: { PublicUpperSidebarLink, UpperSidebarLink },
  props: {
    prop_categories: Array,
    currentPage: String,
    token: Object,
  },
  data() {
    return {
      categories: null,
    };
  },
  async mounted() {
    this.categories = await this.getCategories();
  },
  methods: {
    async getCategories() {
      return this.sortCategories(this.prop_categories);
    },
    sortCategories(categories) {
      let filtered_categories = categories.filter(function (category) {
        if (category.name === 'education and policies') category.name = 'policies';
        return (
          category.name === 'water' ||
          category.name === 'air' ||
          category.name === 'environment' ||
          category.name === 'policies' ||
          category.name === 'energy' ||
          category.name === 'waste'
        );
      });
      return filtered_categories.sort(function (category_1, category_2) {
        return category_2.name - category_1.name;
      });
    },
    openPage(category, pageName) {
      if (!category) this.$emit('pageChanged', { name: pageName });
      else this.$emit('pageChanged', { name: pageName, category: category });
    },
  },
};
</script>

<style scoped></style>
